import { useEffect } from 'react'
import BottomSheetContent from './BottomSheetContent'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const TITLE_CLASS = 'text-[#232323] text-sm font-medium leading-tight'
const BODY_CLASS = 'text-[#6a6e6e] text-sm font-normal leading-tight'

const PASSAGES = [
  {
    title: 'NAV',
    body: 'NAV or Net Asset Value is the price of a single unit of a mutual fund. It changes daily based on the market value of its underlying assets.'
  },
  {
    title: 'Total Expense Ratio',
    body: "Total Expense ratio is the fee charged by the fund house for managing your investments. It is deducted from that day's NAV before it is declared on the next day."
  },
  {
    title: 'Exit Load',
    body: 'Exit load is a charge imposed if you withdraw from a fund (partially or fully) before the specified period.'
  },
  {
    title: 'Stamp Duty',
    body: 'Stamp duty is a government tax levied on purchase or transfer of mutual fund units.'
  },
  {
    title: 'Lock-in Period',
    body: 'Lock-in period is the minimum period you must stay invested in a fund before any redemption is allowed.'
  },
  {
    title: 'Benchmark Index',
    body: "Benchmark index is a standard market index chosen by the fund house as a reference to compare a fund's performance."
  }
] as const

export const FundInformationContent = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Fund Information'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='flex flex-col gap-4'>
        {PASSAGES.map((passage) => (
          <HelpDialogPassage
            key={passage.title}
            accessibleLabel={`${passage.title}. ${passage.body}`}
          >
            <span className={TITLE_CLASS}>{passage.title}</span>
            <br />
            <span className={BODY_CLASS}>{passage.body}</span>
          </HelpDialogPassage>
        ))}
      </div>
    </BottomSheetContent>
  )
}
